import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import Floading from "../../components/Floading/Floading";
import Swal from "sweetalert2";
import FModal from "../../components/FModal/FModal";
import AlertModal from "../AlertModal/AlertModal";
import { AlertModalKyc } from "../AlertModalKyc/AlertModalKyc";
import withReactContent from "sweetalert2-react-content";

const ProviderComponent = ({ children }) => {
  const { loading, alert, removeAlert, kycAlert,checkToken } = useContext(AuthContext);
  const [isOpen, setIsOpen] = useState(true);
  const MySwal = withReactContent(Swal);

  useEffect(() => {
    alert.enabled == false ? setIsOpen(false) : setIsOpen(true);
  }, [alert]);

  useEffect(() => {}, [kycAlert]);

  const openAlert = (ModalComponent) => {
    MySwal.fire({
      showCloseButton: true,
      showCancelButton: false,
      showConfirmButton: false,
      html: ModalComponent,
    });
  };

  return (
    <>
      {alert.enabled != false ? (
        <FModal
          isOpen={isOpen}
          okButton={true}
          title={alert.title}
          body={<AlertModal message={alert.message} type={alert.type} />}
          okButtonTitle={alert.okButtonTitle}
          okButtonclassName={alert.okButtonclassName}
          okButtonAction={() => {
            checkToken()
            try {
              removeAlert();
              alert.continueAction();
            } catch (e) {
              removeAlert();
            }
          }}
        />
      ) : null}

      {kycAlert.enabled != false
        ? openAlert(<AlertModalKyc type="PENDING" />)
        : null}

      {loading ? <Floading open={loading} /> : null}
      {children}
    </>
  );
};

export default ProviderComponent;
